import type { Environment } from '../../api/types.ts';

/**
 * Whether the top bar draws the environment badge.
 *
 * Owner, 2026-09-25: the TESTNET/PAPER badge ("TESTNET binance") is hidden.
 * LIVE keeps it, red, because orders there move real money; an unknown
 * environment (still loading, or a failed read) draws nothing, as before.
 */
export function showsTopBarEnvironmentBadge(environment: Environment | undefined): boolean {
  return environment === 'live';
}
